import BlogSection from '@/components/BlogSection';
import Footer from '@/components/Footer';

export default function BlogPage() {
  return (
    <div className="pt-20">
      <BlogSection />
      <Footer />
    </div>
  );
}
